<template>
  <nav-bar title="重置密码" />
  <Content :bottom="0">
    <div class="register">
      <div class="form">
        <van-form @submit="onSubmit">
          <van-field
          :readonly="readonly"
            label-width="auto"
            placeholder="手机号码"
            left-icon="phone-o"
            v-model="username"
            name="username"
            type="digit"
            :rules="rules.username"
          />
          <van-field
            label-width="auto"
            placeholder="验证码"
            left-icon="phone-o"
            v-model="code"
            name="code"
            type="digit"
            :rules="rules.code"
          >
            <template #button>
              <van-button
                size="small"
                :loading="verifyLoading"
                type="primary"
                loading-text="加载中..."
                @click="sendVerifyCode"
                >发送验证码</van-button
              >
            </template>
          </van-field>
          <van-field
            label-width="auto"
            placeholder="新密码"
            left-icon="closed-eye"
            v-model="password"
            name="password"
            type="password"
            autocomplete
            :rules="rules.password"
          />
          <van-field
            label-width="auto"
            placeholder="再次填写新密码"
            left-icon="eye-o"
            v-model="verifyPassword"
            name="verifyPassword"
            type="password"
            autocomplete
            :rules="rules.verifyPassword"
          />
          <div class="button">
            <van-button
              block
              :loading="loading"
              loading-text="提交中..."
              type="primary"
              native-type="submit"
              >提交</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </Content>
</template>

<script>
import { Toast } from 'vant'
import { sendVerifyCode, reset } from '@/api/user'

export default {
  name: 'ResetPassword',
  data() {
    return {
      readonly: false,
      flag: false,
      loading: false,
      verifyLoading: false,
      isOpenEye: false,
      rightIcon: 'closed-eye',
      inputType: 'password',
      name: '',
      username: this.$store.state.userInfo.username || '',
      code: '',
      password: '',
      verifyPassword: '',
      nickName: '',
      pid: '',
      rules: {
        name: [{ required: true, message: '请填写的昵称' }],
        username: [
          { required: true, message: '请填写手机号码' },
          { validator: this.phoneValidator, message: '手机号码格式错误' }
        ],
        code: [{ required: true, message: '请填写验证码' }],
        password: [
          { required: true, message: '请填写密码' },
          {
            validator: this.passwordValidator,
            message: '密码为6-16数字字母组合'
          }
        ],
        verifyPassword: [
          { required: true, message: '请再次填写密码' },
          {
            validator: val => val === this.password,
            message: '两次密码填写不一致'
          }
        ]
      }
    }
  },
  watch: {
    isOpenEye(val) {
      if (val) {
        this.rightIcon = 'eye-o'
        this.inputType = 'text'
      } else {
        this.rightIcon = 'closed-eye'
        this.inputType = 'password'
      }
    }
  },
  mounted () {
    if (this.$store.state.userInfo.username) {
      this.readonly = true
    }
  },
  methods: {
    // 验证手机号码
    phoneValidator(val) {
      return /1\d{10}/.test(val)
    },
    // 验证密码
    passwordValidator(val) {
      return /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(val)
    },
    sendVerifyCode() {
      if (!/1\d{10}/.test(this.username)) {
        Toast('请输入正确手机号码')
      } else {
        const data = {
          tel: this.username
        }
        this.verifyLoading = true
        sendVerifyCode(data).then(res => {
          this.verifyLoading = false
          if (res.status && res.status === 0) {
            Toast.success(res.message)
          } else {
            Toast.fail(res.message)
          }
        })
      }
    },
    // 注册
    onSubmit(values) {
      this.loading = true
      if (!this.flag) {
        this.flag = true
        reset(values)
          .then(res => {
            if (res.status === 200) {
              Toast.success('重置成功')
              this.$router.push('/login')
            } else if (res.status === -100) {
              Toast.fail(res.message)
            }
            this.loading = false
            this.flag = false
          })
          .catch(() => {
            Toast.fail('重置失败')
            this.loading = false
            this.flag = false
          })
      }
    }
  }
}
</script>

<style scss scoped>
.register ::v-deep(.van-cell__value) {
  background: #fff;
  padding: 5px 10px;
}
.register ::v-deep(.van-field__control::placeholder) {
  color: #666;
}
.register ::v-deep(.van-field__control) {
  font-size: 12px;
  height: 20px;
  line-height: 20px;
}
.register ::v-deep(.van-field__left-icon) {
  display: flex;
  align-items: center;
}
.register {
  width: 100%;
}

.button {
  margin: 16px;
}
</style>
